import { Divider } from '@mui/material';
import { colors } from '@sweep-io/sweep-design';

export const Separator = () => {
  return (
    <Divider
      orientation="vertical"
      flexItem
      sx={{ margin: '-4px 0', borderColor: colors.grey[120] }}
    />
  );
};
